import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";
import "@popperjs/core/dist/umd/popper.min";
import "/src/styles/global.css";
import "aos/dist/aos.css";

import React from "react";
import { CookieConsentProvider } from "./src/context/CookieConsentContext";

export const onInitialClientRender = () => {
  // Optional: weitere Initialisierungen
};

export const wrapRootElement = ({ element }) => (
  <CookieConsentProvider>{element}</CookieConsentProvider>
);
